var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSurvivalRate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 375 302",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.5;fill:#C3E3F1;enable-background:new;}\n\t.st1{fill:#87C8E4;}\n\t.st2{fill:none;stroke:#87C8E4;stroke-width:2.594;stroke-miterlimit:10;}\n\t.st3{fill:#C3E3F1;}\n\t.st4{fill:#49ABD7;}\n\t.st5{fill:#49ABD7;stroke:#42515A;stroke-width:1.297;stroke-miterlimit:10;}\n\t.st6{fill:#C3E3F1;stroke:#42515A;stroke-width:0.8647;stroke-miterlimit:10;}\n\t.st7{fill:#FFFFFF;stroke:#42515A;stroke-width:0.7609;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#42515A;stroke-width:2.2827;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0.1729,22.7927;}\n\t.st9{fill:#42515A;}\n\t.st10{fill:#FEC010;}\n\t.st11{fill:none;stroke:#FEC010;stroke-width:2.594;stroke-miterlimit:22.93;}\n\t.st12{fill:none;stroke:#FEC010;stroke-width:2.594;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    className: "st0",
    width: 374.3,
    height: 301.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 260,
    className: "st1",
    width: 374.3,
    height: 41.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0.3,
    y1: 255.7,
    x2: 374.7,
    y2: 255.7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M53.1,129.7c-2.1,20,8.1,31.4,23,24.2c-11.7,2.6-22.6-4.8-21.6-25.7l-0.3-0.7c-0.3,0.1-1.7,0.7-5-0.9 c-10.2-4.4-8.4-12-8.6-15.6C40.1,112.8,33.6,129.8,53.1,129.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M330.2,132.1c-0.7-9.3-2.7-15.4-12.4-19.1c-0.3-1.7-7.9-28.1-36.4-27.4c-11.7,3.6-2.5-4.4-15.9-12.4 c-16-9.3-51.3-0.1-41.1,11.8c-15.2-17.6-33.5,9.5-30.7,10.8c-17.5-8.2-39.3,6-37.4,30.9c-3.9-0.4-7.7,1.4-9.7,4.8 c-16.6-7.4-21.7,9.5-32.8,7.3c10.8-7.2-13.1-8.5-13.9-7.5c0.5-1.7-0.1-3.5-1.5-4.5c-2.4-2.1-13.3-1.1-13.3-1.1 c-0.8-7.3-10.2-9.9-14.6-8.5c-5.4-17-11.8-3.8-16.3-15c-2-4.8-2-2,1-11S42.8,73.5,40.1,79.6c-1.9,4.2-0.3,5.5,0.4,3.3 c1.6-4.8,7.1,1.6,7.8,6.6c-1,6.7-16.7,8-5.9,18.5c-0.5,5.4,6.9,17.9,16.6,16.9c-3.5,11,6.7,36.2,31.4,20.7 c-5.7,6.7,0.3,21.8,11.4,16.1c0,0-4,6,2.9,5c0,0-2.9,15.9,4.4,22c25.9,23,54.6-16.9,54.2-33.5c0.6,32.5,51.8,33.2,53.9-4.4 c0.2,2,0.8,3.9,1.6,5.7c2.9,4.9,10.2,10.1,16.7,4.2c-2.9-10.8,3.5-15.8,4-17.4c-3.3-7.1,11.3-8.5,12.9-8.1 c-1.1,0.3-16.7,3.4-9.6,8.9c-5.1,1.5-8.4,30.8,6.6,18.2c0-0.1-8.9,27.5,8.7,29.2c-4.2-7.6,5.4-12.8,11.9-15 c-14.9,6.3-8.3,35.8,14.3,20.4c0,0-1.9,5.9,18.2,6.9c20.1,1,23-28.7,23-28.7C334.6,164.3,342.5,147.7,330.2,132.1z M61.9,119.5 c-4.8,4.7-14.4-1.5-11-7.9C50.9,111.6,51.8,121.8,61.9,119.5z M73.3,133c-5.1-7.6-9.5-0.3-9.5-0.3C65,127.5,71.9,126.2,73.3,133z  M100.6,158.4c0,0,3.8-1.4,3.2-5.4c-0.3-2.3-0.9-4.4-1.9-6.5C107.4,149.6,106.8,157.5,100.6,158.4z M118.5,157 c-0.3,0.1-12.4,7-7.9,12.7c-5.8,0.6,2.9,14.9,3.7,15.9c-4.6-1.6-10-14.6-5.7-16c-0.4-2.5,0.2-5.1,1.6-7.2 C112.7,158.8,118.5,157,118.5,157L118.5,157z M140.2,136.5c-6.7-1.6-18.1,7.1-18.1,7.1s6.6-7.8,10.9-8.5 C135.5,134.8,138,135.2,140.2,136.5L140.2,136.5z M149.1,176.5c-5.6,3.1-10,1.6-10,1.6s13.1-2.5,16.9-20.2 C156.3,156.4,154.7,173.4,149.1,176.5z M228.8,130.3c-4.9,1.4-10.5,6.6-11.7,14.4c-0.1-1.7-0.3-3.4-0.6-5.2c2.2-6.4,9-8.8,9-8.8 c-1.2-2-1.2-4.5,0.1-6.5L228.8,130.3z M256.3,123.6c2-2.6,41.6,2.7,35.5,18.9c16.7,2.5,26.2,32.9,4.3,32.3 c15.8-6.6-0.6-35.6-14.6-31C300.7,130,258.4,123.1,256.3,123.6z M264.9,96.4c-9-15.9-28.7-2.1-28.7-2.1s11.5-10.8,20.1-8 S264.9,96.4,264.9,96.4z M324.3,161.3c4.8-22.7-13.6-28.1-13.6-28.1c6-8.9-3.8-16.3-6.5-15.9s-1.5,5.1-1.5,5.1l-6.9-1.5 c0.8-12.6-12.8-9.6-14.1-9.5c8.2-17.2-20.2-7.1-22.8-6.1c0,0,13.6-7.5,25.7-6.6s16.1,13.1,16.1,13.1s13.1,1.2,16.8,12 c3,8.5,1.2,8.8,0.3,8.6C325.8,135.9,331.3,156.3,324.3,161.3L324.3,161.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M336.5,186.7c0.3-8.6-11.9-0.3-10.1,5.5C327.6,196.3,336.3,195.2,336.5,186.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M319.3,103.2c-3.6-17.7-30.5-24.4-41.2-21C291.6,75.7,319.4,72,319.3,103.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M148.5,189.5c0,0,9.6-0.7,12.8-5.4s2.1-14.4,2.1-14.4S159.3,182.9,148.5,189.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M329.7,175.6c0,0,7.7-2.1,10.8-6.7c5.4-7.9-0.4-19.1-0.4-19.1S340.2,169,329.7,175.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 95.5,
    cy: 65.4,
    r: 22.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 96.3,
    cy: 62.6,
    r: 22.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 96.4,
    cy: 62.5,
    r: 18.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9986 -5.233596e-02 5.233596e-02 0.9986 -3.1419 5.0961)",
    className: "st7",
    cx: 95.7,
    cy: 62.5,
    rx: 17.5,
    ry: 18.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st8",
    cx: 96.3,
    cy: 62.5,
    r: 14.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 96.3,
    cy: 63.3,
    r: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M108.1,68.4l-5.5-2.7l-2.9-1.4l-1.3-0.7l-0.6-0.3l-0.4-0.2c-0.6-0.4-0.3-1.3-0.4-2v-2.8c-0.1-2,0-4-0.2-6 c-0.1-0.6-1-0.6-1,0c-0.2,2.1,0,4.2,0,6.1v3.2c-0.1,0.7,0.1,1.4,0.5,1.9c0.4,0.6,1.6,1,2.3,1.3l3,1.5l5.9,2.9 C108.1,69.6,108.6,68.7,108.1,68.4L108.1,68.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.7,225.9c0,4.5,2.2,6.1,3.1,6.1c1,0,6.7-2.1,6.8-1.1c0.1,1-3.5,3.6-6,3.5c0,0,4.2,6.1,7.2,4.8 c3-1.4,3.5-4,5.4-4.8c1.9-0.9,3.5-0.7,2.7,0.3s-4.2,1.6-5.4,3.7c-1.2,2.1-2.2,3.5,0.9,3.2c3.1-0.3,8.3-2.4,8.6-5.4v-0.3 c0,0.1,0,0.2-0.1,0.3c0.6,0.2,2.1,1.7,3.1,3.4c0.7,1.3,1.1,2.6,1.4,4.1H52.3l-0.4,0.2c-0.3,0.2-0.4,0.5-0.4,0.9 c0.3,8.2,4.9,14.7,11.4,17.5l0.3,0.2h13.6c6.4-2.9,11-9.3,11.4-17.6c0-0.2-0.1-0.3-0.1-0.5c0-0.3-0.3-0.6-0.6-0.6h0H76.3 c0.1-0.1,0.1-0.3,0.2-0.4l0,0c0.3-0.5,0.3-0.9,0.5-1.1c0.7-1.7,1.6-3.9,2.3-4.3l0,0c1.3,3.2,7.8,3.7,11.4,2.9 c3.6-0.9,2.1-2,0.1-3.9c-2-1.9-6-1.5-7.2-2.2c-1.2-0.7,0.5-1.6,2.9-1.3s3.6,2.9,7.5,3.4c3.9,0.4,6.9-8,6.9-8 c-2.8,1-7.6-0.8-7.8-1.8c-0.2-1,7-1,8.1-1.3c1.1-0.3,3-2.9,1.8-8c-1.2-5.1-8.7-3.6-8.7-3.6s-5.1,9.1-6.6,9.3c-1.5,0.3,3-8.7,3-8.7 c-2.9-0.3-10.2,3.7-10.2,3.7s0.5,10.5-1,10.4c-1.6-0.2,0-9.4,0-9.4c-2.8,1-5.4,4.8-5.4,4.8c-3.3,6.1,3.7,10.7,3.7,10.7l0,0 c-0.4,2.7-1.1,5.4-2.2,7.9c-0.2,0.4-0.4,0.8-0.5,1.2h-8.5c0.8-3.2,0.9-6.6,0.3-9.9c-0.6-3.6-0.4-7.2,0.4-10.7 c0,0,10.4-2.3,8.5-11.6c0,0-1.9-6-5.1-8.5c0,0-1,10.4-2.9,9.9c-1.9-0.4,1.9-11.7,1.9-11.7s-7.7-8.6-11.4-9.6c0,0,2.5,13.4,0.7,12.4 c-1.8-1-4.9-14.7-4.9-14.7s-8.9-5.6-12.2,0.3s-1.8,10-0.6,11c1.2,1,10.3,4.2,9.7,5.4c-0.6,1.3-7.3,1.1-10.3-1.4 c0,0,0.7,12.1,5.8,13.4c5.1,1.3,7.5-1.6,10.6-0.8s5,2.7,3.3,3c-1.7,0.3-6.7-2.2-9.9-0.7l-0.8,0.3c-1.3-0.2-2.7-0.1-4,0.3l1.3,1.4 c-0.3,0.8,0.2,1.6,2.2,2.9h0.2c0.6,1,1,1.7,0.6,1.8c-0.4,0.1-7.2-5.7-7.2-5.7S36.6,221.4,36.7,225.9z M79.4,237.5l-0.2-0.4 L79.4,237.5z M65,225.9l-0.3,0.3L65,225.9z M57,227.6l1.2,0.2c0,0.3-0.1,0.6-0.3,0.9C57.6,228.7,57.3,228.3,57,227.6z M60.4,233 c1.3-1.6,2.2-3.5,2.4-5.5c0.7-0.2,1.4-0.6,1.9-1.2l0,0c0.7,0.9,1.2,4.1,1.5,6.5c0.1,0.3,0.1,0.9,0.2,1.6c0.1,0.3,0.1,0.5,0.1,0.8 c0.1,2.2-0.2,4.4-0.8,6.5c-0.3-0.7-0.7-1.4-1.1-2.1C62.9,236.7,60.4,233,60.4,233L60.4,233z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 19.5599 359.8651)",
    className: "st10",
    cx: 221.3,
    cy: 168.4,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M150.1,99.4c5.4,4.2,11.8-4.2,6.3-8.4C151,86.9,144.7,95.3,150.1,99.4z M154.6,93.4c2.4,1.8-0.3,5.5-2.8,3.7 S152.3,91.6,154.6,93.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 346.6,
    cy: 181,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 244.4,
    cy: 203.9,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 279.5,
    cy: 184.6,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 338,
    cy: 124.9,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 138.6,
    cy: 111.4,
    r: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M135.8,103.6l1-0.3l1-0.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 137.5,
    y1: 106.4,
    x2: 136.8,
    y2: 103.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M130,109.6l0.3-1c0.1-0.3,0.2-0.6,0.3-1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 133.2,
    y1: 109.6,
    x2: 130.3,
    y2: 108.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M132.3,117.3c-0.3-0.2-0.5-0.4-0.7-0.7l-0.7-0.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 133.8,
    y1: 114.6,
    x2: 131.6,
    y2: 116.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M141.4,119.6l-1,0.3l-1,0.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 139.7,
    y1: 116.7,
    x2: 140.4,
    y2: 119.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M147.5,112.7l-0.3,1c-0.1,0.3-0.3,0.6-0.3,1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 144.2,
    y1: 112.8,
    x2: 147.2,
    y2: 113.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M144.7,104.6l0.7,0.8l0.6,0.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 143.1,
    y1: 107.5,
    x2: 145.4,
    y2: 105.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M166,182.7c-2.1,4.9,5.4,8.1,7.5,3.2C175.7,181,168.1,177.8,166,182.7z M171.4,185c-0.9,2.2-4.2,0.7-3.3-1.5 C169,181.4,172.3,182.9,171.4,185z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 158.8,
    cy: 85.3,
    r: 2.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 167.4,
    cy: 197.4,
    r: 2.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 166.8,
    y1: 194.4,
    x2: 166.4,
    y2: 192.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 164.2,
    y1: 196.4,
    x2: 162.4,
    y2: 195.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 164.6,
    y1: 199.4,
    x2: 163.2,
    y2: 200.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 168.2,
    y1: 200.7,
    x2: 168.5,
    y2: 202.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 170.9,
    y1: 198.3,
    x2: 172.7,
    y2: 198.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 170.2,
    y1: 195.1,
    x2: 171.5,
    y2: 193.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M343.2,130.2c-6.2,1.9-3.5,11.4,2.9,9.6S349.4,128.4,343.2,130.2z M345.2,137.1c-2.7,0.9-4-3.5-1.2-4.2 C346.7,132.1,347.9,136.4,345.2,137.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M255.9,198.7c-6.2,1.9-3.4,11.4,2.9,9.6C264.9,206.5,262.2,196.9,255.9,198.7z M257.9,205.6 c-2.7,0.9-4-3.5-1.2-4.2C259.5,200.6,260.7,204.8,257.9,205.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 179.8,
    cy: 193,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 235.1,
    cy: 185.3,
    r: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M232.3,177.5l1-0.3l1-0.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 234,
    y1: 180.4,
    x2: 233.3,
    y2: 177.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M226.5,183.7l0.3-1c0.1-0.3,0.2-0.7,0.3-1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 229.7,
    y1: 183.7,
    x2: 226.8,
    y2: 182.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M228.8,191.4l-0.7-0.7l-0.7-0.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 230.3,
    y1: 188.6,
    x2: 228.1,
    y2: 190.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M237.9,193.5c-0.3,0.2-0.6,0.3-1,0.3l-1,0.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 236.2,
    y1: 190.7,
    x2: 236.9,
    y2: 193.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M244,186.7l-0.3,1c-0.1,0.3-0.3,0.7-0.3,1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 240.7,
    y1: 186.7,
    x2: 243.7,
    y2: 187.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M241.2,178.6l0.8,0.8c0.2,0.2,0.4,0.5,0.6,0.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 239.6,
    y1: 181.5,
    x2: 241.9,
    y2: 179.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M95.2,53.6c0.5-0.6,1-1.3,1.4-2h-0.9c0.3,0.8,0.8,1.4,1.5,2c0.1,0.3,0.4,0.4,0.7,0.2s0.4-0.4,0.2-0.7 c-0.1-0.1-0.1-0.2-0.2-0.2l-0.5-0.5l-0.3-0.3H97v-0.2l-0.3-0.6c-0.1-0.2-0.4-0.3-0.6-0.2c-0.1,0-0.2,0.1-0.2,0.2 c-0.4,0.7-0.8,1.4-1.3,2c-0.1,0.2,0,0.5,0.2,0.6C95,53.9,95.2,53.9,95.2,53.6L95.2,53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M106.2,67.1c0.4,0.7,0.8,1.4,1.2,2l0.4-0.7l-1.6,0.3l-0.8,0.3c-0.3,0.1-0.4,0.3-0.3,0.6 c0.1,0.2,0.3,0.4,0.6,0.3l0.8-0.3l0.7-0.2h0.6c0.2,0,0.4-0.2,0.4-0.3c0-0.2,0-0.3-0.2-0.4H108l-0.2-0.3l-0.4-0.6l-0.5-0.8 c-0.1-0.2-0.3-0.2-0.5-0.2c-0.3,0.2-0.3,0.3-0.2,0.6L106.2,67.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurvivalRate);
export default __webpack_public_path__ + "static/media/survival-rate.3b8fde5d2203946d97315d4274719504.svg";
export { ForwardRef as ReactComponent };